import { ACCESS_TOKEN_KEY } from "../../../constants";
import useAuthStore from "../../../store/auth";
import usePaymentStore from "../../../store/payment";

/**
 * Custom hook to log out a user.
 * @returns {object} - logout function.
 */
function useLogout() {
  const [setUser, setIsAuthenticated] = useAuthStore(state => [
    state.setUser,
    state.setIsAuthenticated,
  ]);
  const [clearBookingsToPay] = usePaymentStore(state => [state.clearBookingsToPay]);

  const logout = () => {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
    setUser(null);
    setIsAuthenticated(false);
    clearBookingsToPay();
  };

  return { logout };
}

export default useLogout;
